import { axios, BaseApiUrl, BaseUrl } from "../axios_config";


//查询盘点列表
export const getInventoryInfoList = params => {
	return axios.post(`${BaseApiUrl}/TFInventoryInfo/GetInventoryInfoList`, params);
           };

//审核盘点单
export const approvedInventory = params => {
    return axios.get(`${BaseApiUrl}/TFInventoryInfo/ApprovedInventory`, { params: params });
};

//盘点单导出
export function inventoryInfoAsyncOut(params) {
    return axios.post(`${BaseApiUrl}/TFInventoryInfo/InventoryInfoAsyncOut`, params);
}


           